export class DataSheetInput {
  id: bigint;
  mat_id: string;
  mat_name: string;
  mat_desc: string;
  retal: string;
  barcode: number;
  width: number;
  height: number;
  depth: number;
  weight: string;
  unit: number;
  side: string;
  id_process: string;
  lager: string;
  location: string;
  reference: string;
  disband: number;
  diecutting: number;
}
